import axios from 'axios';

export const isDev = import.meta.env.MODE === 'development';

export const API_URL = window.origin;
export const CONTENT_URL = '';
export const STORAGE_URL = 'https://95160e01.gcdn.easyrocket.net';
export const STORAGE_FOR_GAMES = '/storage/games/vertically';

export const apiProvider = axios.create({ baseURL: API_URL });

export const isProductionEnv =
  (!window.origin.includes('coppelia.openapi.club') && !window.origin.includes('localhost')) ||
  import.meta.env.VITE_DOMAIN?.includes('wizebets');
